const EFAS_URLS = [
    "www.efas.local",
    "dev.efas.eu",
    "stage.efas.eu",
    "european-flood.emergency.copernicus.eu",
]

export function isEfasEnvironment(hostname: string, isDev: boolean, localProduct?: string): boolean {
    return (isDev && localProduct === "efas") || EFAS_URLS.includes(hostname);
}

const IS_EFAS = isEfasEnvironment(window.location.hostname, import.meta.env.DEV, import.meta.env.VITE_LOCAL_PRODUCT);
export default IS_EFAS;

export const IS_EFAS_PRODUCTION = window.location.hostname === "european-flood.emergency.copernicus.eu";

export const SMALL_DISPLAY = window.outerWidth < 600;
